import actions from './disputes.actions'
import getters from './disputes.getters'
import mutations from './disputes.mutations'
import state from './disputes.state'

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
